import { Dispatch, SetStateAction, useCallback, useState } from 'react'

type UseImageUrls = {
  imageUrls: string[]
  deleteImageUrls: (index: number) => void
  handleImageUrls: (value: string) => void
  rearrangeImages: (index: number, type: 'prev' | 'next') => void
  setImageUrls: Dispatch<SetStateAction<string[]>>
}

const useImageUrls = (): UseImageUrls => {
  const [imageUrls, setImageUrls] = useState<string[]>([])

  const handleImageUrls = useCallback(
    (value: string) => {
      setImageUrls((prevState) => [...prevState, value])
    },
    [setImageUrls]
  )

  const deleteImageUrls = useCallback(
    (index: number) => {
      setImageUrls((prevState) => {
        const nextState = prevState.filter((_, i) => i !== index)
        return [...nextState]
      })
    },
    [setImageUrls]
  )

  const rearrangeImages = useCallback(
    (index: number, direction: 'prev' | 'next') => {
      setImageUrls((prevState) => {
        if (direction === 'prev') index -= 1
        prevState.splice(index, 2, prevState[index + 1], prevState[index])
        return [...prevState]
      })
    },
    [setImageUrls]
  )

  return {
    imageUrls,
    handleImageUrls,
    deleteImageUrls,
    rearrangeImages,
    setImageUrls,
  }
}

export default useImageUrls
